import { render, staticRenderFns } from "./DocumentPOSindex.vue?vue&type=template&id=addeb29e&scoped=true"
import script from "./DocumentPOSindex.vue?vue&type=script&lang=js"
export * from "./DocumentPOSindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addeb29e",
  null
  
)

export default component.exports